import { userConstants } from "../../constant";

export function newArrival(state = {}, action) {
  switch (action.type) {
    case userConstants.NEW_ARRIVAL_PRODUCTS:
      return {
        newArrival: action.products,
      };

    default:
      return state;
  }
}
